import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export async function getLocations() {
  try {
    const response = await axios.get(`${API_URL}/ms-monitoreo/monitoreo/nodos/locations`);
    const responseData = await response.data.data;
    return responseData;
  } catch (error) {
    return 'Error found when fetching data';
  }
};

